<template>
	<div class="text-xs bg-grey-1 rounded-2xl max-w-217 mb-6">
		<div class="p-6">
			<div class="text-grey mb-2">General</div>

			<div class="flex justify-between items-center mb-2">
				<div>Username</div>
				<div>{{ username }}</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Market</div>
				<div>Indonesia</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Promotor Code</div>
				<div>
					<span class="mr-2">{{ $store.getters.getReferralCode }}</span>
					<IconCopy class="cursor-pointer" @click.native="copyToClipboard($store.getters.getReferralCode)" />
				</div>
			</div>
		</div>

		<hr class="border-2 border-transparent border-grey-4 my-0">

		<div class="p-6">
			<div class="text-grey mb-2">Personal Information</div>

			<div class="flex justify-between items-center mb-2">
				<div>Full Name</div>
				<div>{{ username }}</div>
			</div>

			<div class="flex justify-between items-center mb-2">
				<div>Phone Number</div>
				<div>{{ phoneNumber }}</div>
			</div>

			<div class="flex justify-between items-center">
				<div>Email</div>
				<div>{{ email }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import IconCopy from '../../../components/icons/IconCopy.vue'

export default {
	name: 'SettingProfil',

	components: {
		IconCopy,
	},

	data() {
		return {
		}
	},

	computed: {
		email() {
			return this.$store.state.account.email || '-'
		},

		firstName() {
			return this.$store.state.account.firstName || '-'
		},

		username() {
			return this.$store.getters.username
		},

		phoneNumber() {
			return this.$store.state.account.phoneNumber || '-'
		},
	},

	created() {
	},

	methods: {
		async copyToClipboard(value) {
			await navigator.clipboard.writeText(value)
		},
	},
}
</script>

<style scoped></style>